module.exports = __webpack_public_path__ + "img/blue-line.c11ca41a.png";